import { getCurrentDomainConfig, getStorageKey } from '@/utils';
import { getCurrentIpGeolocation } from './ip';
import { DOMAIN_CONFIGS } from '@/configs';

/**
 * 默认国家
 * @returns
 */
export const getDefaultCountry = () => {
  const country: string =
    localStorage.getItem(getStorageKey('country')) || DOMAIN_CONFIGS.SINOMOTIVE.defaults.country;
  return country;
};

/**
 * 初始化国家和货币
 */
export const getLocalIpCountry = async () => {
  let countryCode = getCurrentDomainConfig().defaults.country;
  try {
    const res = await getCurrentIpGeolocation();

    if (res?.countryCode) {
      countryCode = res?.countryCode;
    }
  } catch (error) {}

  return countryCode;
};
